import React from "react";
import Profile from "../Components/Profile/Profile";

const ProfilePage = () => {
  return <div>
    <Profile />
  </div>;
};

export default ProfilePage;
